export class ColorHelper {
    public static getContrastingTextColor(color: string): string {
        if (!color || color == null || color == '' || color == 'null' || this.isLightColor(color)) {
            return "#000000";
        }
        else {
            return "#ffffff";
        }
    }

    public static isLightColor(color: string): boolean {
        // Variables for red, green, blue values
        var r, g, b, hsp;

        // Check the format of the color, HEX or RGB?
        if (color.match(/^rgb/)) {
            // If RGB --> store the red, green, blue values in separate variables
            let rgbColor = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

            r = rgbColor[1];
            g = rgbColor[2];
            b = rgbColor[3];
        }
        else {
            // If hex --> Convert it to RGB.
            let hexColor = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

            r = hexColor >> 16;
            g = hexColor >> 8 & 255;
            b = hexColor & 255;
        }

        // HSP equation
        hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
        );

        // Using the HSP value, determine whether the color is light or dark
        if (hsp > 127.5) {
            return true;
        }
        else {
            return false;
        }
    }
}
